'use client';

import { Box, Title, TitleLevels, TrilogyColor } from '@bytel/trilogy-react';

import { UserType } from '@app-types/user';

import { LoginPrompt } from '@components/connection';

interface ConnectionBlocProps {
    user?: UserType;
}

export function ConnectionBlock({ user }: Readonly<ConnectionBlocProps>) {
    if (!user) {
        return <LoginPrompt />;
    }

    return (
        <Box backgroundColor={TrilogyColor.INFO} shadowless className='is-aligned-center'>
            <Title inverted level={TitleLevels.FOUR}>
                Bonjour <span className='is-capitalized'>{user?.given_name?.toLowerCase()}</span>
            </Title>
        </Box>
    );
}
